import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { InterviewTypeListContainerContent } from './InterviewTypeListContainerContent';
import type { InterviewTypeListContainerProps } from './types';

export type { InterviewTypeListContainerProps };

function InterviewTypeListSkeleton() {
  return (
    <div className="grid gap-3">
      <Skeleton className="h-[72px] rounded-lg" />
      <Skeleton className="h-[72px] rounded-lg" />
      <Skeleton className="h-[72px] rounded-lg" />
    </div>
  );
}

export function InterviewTypeListContainer(props: InterviewTypeListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<InterviewTypeListSkeleton />}>
        <InterviewTypeListContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
